import React from "react";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import { hasPermission } from "../utils/permissionHelper";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { Link } from "react-router-dom";


const Miscgrnmenu = () => {
   useAuthRedirect();
   const canEntry  = hasPermission("Branch office GRN", "entry");
  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Branch Office - Goods Receipt Note
          </h2>
          <Time />
        </section>

     <div className="container">
      <table className="transaction-table ">
        <thead>
          <tr>
            <th className="table-header">Transaction</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><Link to="/inventory/miscGrnView">GRN (Misc)</Link></td>
          </tr>
          {canEntry && (
          <tr>
            <td><Link to="/inventory/miscGrnInspection">GRN Inspection (Misc)</Link></td>
          </tr>
          )}
          <tr>
          {/* <td><Link to="/inventory/miscgrnRejectionView">GRN Rejection (Misc)</Link></td> */}
          </tr>
        </tbody>
      </table>
      </div>
    </div>
    </div>
  );
};

export default Miscgrnmenu;
